import { inject, Service } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { unassignedBoxesActions } from '../actions/unassigned-boxes.actions';
import { selectBoxes, selectHasMore, selectLoaded, selectLoading, selectPage, selectSaving } from '../selectors/unassigned-boxes.selector';

@Service()
export class UnassignedBoxesFacade {
    private readonly store = inject(Store);
    private readonly actions = inject(Actions);

    readonly boxes = this.store.selectSignal(selectBoxes);
    readonly page = this.store.selectSignal(selectPage);
    readonly hasMore = this.store.selectSignal(selectHasMore);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly generated$ = this.actions.pipe(ofType(unassignedBoxesActions.generateBoxesSuccess));
    readonly assigned$ = this.actions.pipe(ofType(unassignedBoxesActions.assignBoxSuccess));

    loadBoxes(): void {
        this.store.dispatch(unassignedBoxesActions.loadBoxes({ page: 1 }));
    }

    loadMoreBoxes(): void {
        this.store.dispatch(unassignedBoxesActions.loadBoxes({ page: this.page() + 1 }));
    }

    generateBoxes(quantity: number): void {
        this.store.dispatch(unassignedBoxesActions.generateBoxes({ quantity }));
    }

    printCartons(codes: string[]): void {
        this.store.dispatch(unassignedBoxesActions.printCartons({ codes }));
    }

    assignBox(cartonCode: string, cellCode: string): void {
        this.store.dispatch(unassignedBoxesActions.assignBox({ cartonCode, cellCode }));
    }

    clear(): void {
        this.store.dispatch(unassignedBoxesActions.clear());
    }
}
